import qs from 'qs';
import Http from 'services/Http';

class AgentInstructionApi {
  list(entityType, entityId) {
    const query = qs.stringify({ entityType, entityId });
    return Http.get(`/v1/instructions?${query}`).then(r => r.data.instructions);
  }

  create(body) {
    return Http.post('/v1/instructions', body).then(r => r.data.instruction);
  }

  activate(id) {
    return Http.post(`/v1/instructions/${id}/activate`).then(r => r.data.instruction);
  }
}

export default new AgentInstructionApi();
